import { useCallback, useEffect, useState } from 'react';
import { useForm } from '../../../hooks/useForm';
import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useLocation } from 'react-router-dom';
import { callApi } from '../../../services/api.service';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { ensureJsonObject } from '../../../utils/validateResponseApi';
import { useTranslation } from 'react-i18next';
import { calculateDv } from '../../../utils/calculateDV';
import { useNotification } from '../../../hooks/useNotification';

export default function useManageCompany() {
    const { t } = useTranslation();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm({
        name: '',
        id_number: '',
        email: '',
        supplier_digit: '',
        supplier_tax_id: '',
        supplier_additional_account_id: '',
        supplier_tax_scheme: '',
        supplier_tax_level_code: ['R-99-PN'],
        //software
        software_id: '',
        software_pin: '',
        //representante_legal
        person_id: '',
        person_first_name: '',
        person_family_name: '',
        person_title: '',
        person_departament: '',
        city_id: '',
        country_id: '',
        state_id: '',
        phone: '',
        address: ''
    });
    const [errorInputs, , , validForm] = useErrorInputs();
    const [isEdit, setisEdit] = useState(false);

    useEffect(() => {
        if (values?.id_number && values?.supplier_tax_id === "31") {
            const dv = calculateDv(values.id_number);
            handleDirectInputChange('supplier_digit', dv);
        }
        else
            handleDirectInputChange('supplier_digit', '');
    }, [values?.id_number, values?.supplier_tax_id])


    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const response = await callApi("location_select", "COUNTRY", {}, userSession.token);
            if (response.data)
                setCountries(response.data);
        } catch (err) {
            console.log(err.message);
        }
    }, [userSession.token]);

    const GetStatesAndCities = useCallback(async (action, variables) => {
        try {
            const response = await callApi("location_select", action, variables, userSession.token);
            if (response.data) {
                if (action === 'STATE')
                    setStates(response.data);
                else {
                    setCities(response.data);
                }
            }
        } catch (err) {
            console.log(err.message);
        }
    }, [userSession.token]);

    useEffect(() => {
        fetchData();
        GetStatesAndCities('STATE', { id_country: 1 });
    }, [fetchData, GetStatesAndCities]);


    const handleChangeCountryState = (e, action) => {
        const { name, value } = e.target;
        if (action === 'STATE') {
            handleDirectInputChange(name, value)
            if (value === 'CO')
                GetStatesAndCities('STATE', { id_country: 1 });
        }
        if (action === 'CITY') {
            handleDirectInputChange(name, value)
            GetStatesAndCities('CITY', { code: value });
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const idCompany = location.state?.config?.data?.id_company;
            if (idCompany) {
                try {
                    const res = await callApi(
                        "company_select",
                        "SELECT_BY_COMPANY_ID",
                        { id_company: idCompany },
                        userSession.token,
                        { findOne: 'true' }
                    );
                    const obj = ensureJsonObject(res.data);
                    obj.supplier_tax_level_code = obj.supplier_tax_level_code.split(',');
                    setAllInfo(obj);
                    setisEdit(true);
                } catch (error) {
                    console.error('Error fetching company data:', error);
                }
            }
        };

        fetchData();
    }, [location.state?.config, userSession.token]);

    const save = async () => {
        console.log('save ', isEdit);
        try {
            values.supplier_tax_level_code = values.supplier_tax_level_code.join(',')
            if (isEdit) {
                await callApi("company_alter", "UPDATE", values, userSession.token);
            } else {
                await callApi("company_alter", "INSERT", values, userSession.token);
            }
            sendNotification({
                msg: t("saveSuccess"),
                variant: "success",
            });
        } catch (error) {
            sendNotification({
                msg: t("messages.saveError"),
                variant: 'error',
            });
        }
    }

    return (
        {
            values,
            errorInputs,
            isEdit,
            countries,
            states,
            cities,
            handleInputChange,
            handleDirectInputChange,
            handleChangeCountryState,
            validForm,
            save,
            t
        }
    )
}
